/**
 * Helpers pour les tags renvoyés par GET /clients/{id}/tags/me (permission métier).
 * Responsabilité: centraliser le découpage des ids par permission sans disperser la logique dans les composants.
 */

import type { IApiClientTagMe, TagPermission } from 'core/interfaces/Me'

export function tagIdsWithPermission(
  tags: readonly IApiClientTagMe[],
  permission: TagPermission
): number[] {
  return tags.filter((t) => t.permission === permission).map((t) => t.id)
}

/** Tous les ids de tags auxquels l'utilisateur connecté a accès sur le client courant. */
export function allMyTagIdsForCurrentClient(
  tags: readonly IApiClientTagMe[]
): number[] {
  return tags.map((t) => t.id)
}
